export type FormatCurrencyOptions = {
    currency?: string
    locale?: string
    maximumFractionDigits?: number
}

export const DEFAULT_LOCALE = "en-GB"
export const DEFAULT_CURRENCY = "USD"

export function formatCurrencyFromCents(
    valueInCents: number,
    {
        currency = DEFAULT_CURRENCY,
        locale = DEFAULT_LOCALE,
        maximumFractionDigits = 0,
    }: FormatCurrencyOptions = {}
): string {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        maximumFractionDigits,
    }).format(valueInCents / 100)
}

export function formatCurrency(
    value: number,
    { currency = DEFAULT_CURRENCY, locale = DEFAULT_LOCALE, maximumFractionDigits = 0 }: FormatCurrencyOptions = {}
): string {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        maximumFractionDigits,
    }).format(value)
}

export type FormatDateOptions = {
    locale?: string
    includeTime?: boolean
}

export function formatDisplayDate(
    date: Date,
    { locale = DEFAULT_LOCALE, includeTime = false }: FormatDateOptions = {}
): string {
    const options: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }

    if (includeTime) {
        options.hour = "numeric"
        options.minute = "2-digit"
        options.timeZoneName = "short"
    }

    return new Intl.DateTimeFormat(locale, options).format(date)
}
